export const ToggleCollapse = () => {

  return {
      type: "ToggleCollapse",
  }
};



// WEBPACK FOOTER //
// ./src/actions/toggle-collapse.js